/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recurringmonths1Inputs */

const en_recurringmonths1 = /** @type {(inputs: Recurringmonths1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`months`)
};

const de_recurringmonths1 = /** @type {(inputs: Recurringmonths1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Monate`)
};

/**
* | output |
* | --- |
* | "months" |
*
* @param {Recurringmonths1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const recurringmonths1 = /** @type {((inputs?: Recurringmonths1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recurringmonths1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_recurringmonths1(inputs)
	return de_recurringmonths1(inputs)
});
export { recurringmonths1 as "recurringMonths" }